<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/pc_banner_rule.jpeg`)">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          キャンペーン一般利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2024年7月26日
        </h2>
        <h3 class="terms-title">
          利用規約と条件：
        </h3>

        <ol class="terms-list">
          <li>
            勝winにご登録いただくお客様は、利用規約に同意していただく必要がございます。利用規約およびそこに明示的に参照している文書は、両当事者間の完全な合意および理解を構成し、当サイトとお客様との間に契約関係を規定いたします。当サイトをご利用いただく前に、これらの利用規約をよく読み、ご理解いただきますようお願いいたします。万が一これらの規約に同意をされない場合は、当サイトを利用しない、またはご利用を継続されませんようお願いいたします。
          </li>
          <li>
            当サイトは関連するキャンペーン告知の内容やキャンペーン内にてお客様に説明を明確にいたします。いかなるプロモーションキャンペーンにご参加いただいた場合も、それらの利用規約に同意されたものとみなします。
          </li>
          <li>
            ボーナスウォレット必要なベット額は複数の特典があり、必要なベット額は合計が計算され，必要なベット額がクリアするまで累積し続けます。また、お客様のボーナスウォレットの残高が100円未満の際、入金時に参加するキャンペーンを選択すると、ボーナスウォレットのボーナスの有効なベット額と必要なベット額は自動的にリセットされます。
          </li>
          <li>
            【ボーナス】に関する説明<br>
            <ul class="list-type-disc">
              <li>
                【ボーナス】は、当サイトがお客様に進呈するキャンペーンボーナスを意味します。
              </li>
              <li>【入金不要ボーナス】をご使用できる出金上限は、15,000円となります。</li>
              <li>
                【ボーナス】は直接出金することができず、当サイトでベットする必要があり、ベット額が規定の20倍に到達した場合、自動的に【現金ウォレット】に移動されます。
              </li>
              <li>
                【ボーナスウォレット】内の全てのキャンペーンに必要な有効なベット額が累積して計算されます。
              </li>
              <li>
                【現金ウォレット】の残高が0となった場合、【ボーナスウォレット】より使用が開始され、ゲームを進行します
              </li>
              <li>
                入金を伴うボーナスは、現金ウォレットの残高が0になった場合ご利用いただける、リベンジするためのボーナスでございます。
              </li>
              <li>
                現金ウォレットの残高でプレイいただき、入金額の2倍以上の金額をベットすることで出金可能となりますが、出金された場合、ボーナスウォレットの残高は自動的に削除されますのでご注意くださいませ。
              </li>
              <li>
                【現金ウォレット】と【ボーナスウォレット】の資金を併せてベットした場合、勝利金はボーナスウォレットに配付されます。
              </li>
              <li>
                「スロット、クラッシュ」での1回625円を超えるベットはできません。超過した場合、違反とみなし、すべての関連ボーナスは没収といたします。
              </li>
              <li>
                Bonus BuyまたはFree Spinsを購入する場合、購入額がベット上限額の規定を超えると違反と見なし，すべての関連ボーナスは没収といたします。
              </li>
              <li>
                「ライブ&テーブル」で3,000円を超えるベットはできません。超過した場合、違反とみなし、すべての関連ボーナスは没収といたします。ライトニングバカラなどの手数料がかかるライブゲームでは手数料を含めた金額が3,000円以下でないといけません。
              </li>
              <li>
                ボーナスベットの反映率：
                キャンペーンやプロモーション活動で獲得金額に条件がある場合、その獲得金額の条件は、さまざまなゲームの種類に応じて異なる変換レートで賭け条件に反映されます。
              </li>
            </ul>
            <div class="">
              <table class="table style-table">
                <thead>
                  <tr>
                    <th class="fw_bold">
                      ゲームのジャンル
                    </th>
                    <th class="fw_bold">
                      反映率
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>スロット</td>
                    <td><span class="fw_bold fs_4">100%</span></td>
                  </tr>
                  <tr>
                    <td>ライブ&テーブル</td>
                    <td><span class="fw_bold fs_4">20%</span></td>
                  </tr>
                  <tr>
                    <td>クラッシュ</td>
                    <td><span class="fw_bold fs_4">20%</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="fw_bold content-p-text">
              ※ボーナスベットは上記反映率に応じて賭け条件が計算されます。
            </p>
            <p class="content-p-text">
              <span class="fw_bold">GekiPachi・競馬: </span>
              全種類のパチスロゲームと競馬は、ボーナスを利用してプレイすることができません。
            </p>
          </li>
          <li>
            【Katsuリベート】に関する説明<br>
            <ul class="list-type-disc">
              <li>
                「フレンド紹介特典Katsuリベート」キャンペーンでフレンド紹介に成功された場合、ご紹介いただいたお客様に【Katsuリベート】が付与されます。
              </li>
              <li>【Katsuリベート】で獲得したボーナスは、ベットをしなくても出金が可能です。</li>
              <li>
                【Katsuリベート】は【現金ウォレット】に移動することができ、2倍のベットを完了後、出金申請が可能です。
              </li>
            </ul>
          </li>
          <li>
            適用される法律およびその他の説明<br>
            <ul class="list-type-disc">
              <li>
                これらの利用規約は、コモロ諸島の法律に準拠いたします。お客様は、本利用規約に起因または関連して生じる、あるいは本利用規約の違反、終了もしくは無効から生じるあらゆる紛争、論
                争、申し立ては、コモロ諸島の裁判所の専属管轄権に服することに同意するものといたします。
              </li>
              <li>
                Lite Playerでご登録のお客様はプロモーションキャンペーンには参加できません。
              </li>
              <li>
                出金を処理する前に、当サイトは、ゲームの公平性を確保するために、お客様のゲームに違法なゲームモードが含まれていないかどうかを確認し、ボーナスの乱用、違法なゲームプレイ、詐欺に対しては一切の寛容な対応を採用いたしません。
                また、以下の行為は違反とみなされます。
              </li>
              <li>
                複数のゲーム アカウントを登録し、スロットマシンのゲームの仕組み、
                ジャックポット、ベットを2倍にするためにボーナスを悪用する。
              </li>

              <li>
                ボーナスにベットする際に、VPNを利用しIPアドレスを隠し、リスクを軽減または排除するために複数回ベットする行為。当サイトは、調査の結果が判明する前に、アカウントを調査し（保留中の出金要求を含む）制限する権利を留保いたします。<br>
                調査の結果が判明し、違反が確認された後、当サイトはお客様のアカウントを閉鎖するか、すべてのプロモーションや特典への参加資格を剥奪する権利を留保いたします。
              </li>
              <li>
                当サイトは、調査の結果が判明する前に、アカウントを調査し（保留中の出金要求を含む）制限する権利を留保いたします。
              </li>
              <li>
                調査の結果が判明し、違反が確認された後、当サイトはお客様のアカウントを閉鎖するか、すべてのプロモーションや特典への参加資格を剥奪する権利を留保いたします。
              </li>
              <li>
                当サイトは、関連する規約にいかなる重大な変更があったとしても、事前の通知なしにそれらをいつでも変更する権利を有します。
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    footerIframe() {
      return 'https://katsuwin.info/iframe/terms-and-conditions'
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
